module.exports = __webpack_public_path__ + "media/images/wines/Schloss-VAUX-rose-brut-b66749303763a93f3559d481b1bd1a56.jpg";